(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  function getFlickity() {
    var carousel = document.querySelector('.product-slideshow');
    if (!carousel || !(window.Flickity && window.Flickity.data)) return null;
    return window.Flickity.data(carousel);
  }

  function findVisualiserCellIndex(flkty) {
    if (!flkty || typeof flkty.getCellElements !== 'function') return -1;
    var cells = flkty.getCellElements() || [];
    for (var i = 0; i < cells.length; i += 1) {
      var cell = cells[i];
      if (!cell || !cell.querySelector) continue;
      if (cell.querySelector('[data-feature="visualiser-v3-desktop"], [data-feature="visualiser-v3-mobile"], [data-feature="visualiser-v2"]')) {
        return i;
      }
    }
    return -1;
  }

  function shouldLockFromNode(node) {
    if (!node) return false;

    var input = null;
    if (node.tagName === 'INPUT') {
      input = node;
    } else if (node.closest) {
      input = node.closest('input');
    }

    if (input && input.matches) {
      if (
        input.matches('fieldset[name="Size"] input') ||
        input.matches('fieldset[name="Finish"] input') ||
        input.matches('fieldset[name="Portrait or landscape?"] input') ||
        input.matches('input[name="properties[Colour tone]"]') ||
        input.matches('input[name="properties[Frame colour]"]')
      ) {
        return true;
      }
    }

    if (node.closest && node.closest('[data-pdp-aged-tone-proxy], .option_colour_tone, .option_frame_colour_new')) {
      return true;
    }

    if (node.closest) {
      var label = node.closest('label[for]');
      if (label) {
        var inputId = label.getAttribute('for');
        if (inputId) {
          var linkedInput = document.getElementById(inputId);
          if (linkedInput && shouldLockFromNode(linkedInput)) {
            return true;
          }
        }
      }
    }

    return false;
  }

  function getVisualiserRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[data-feature="visualiser-v3-mobile"] .pdpv3m-root, [data-feature="visualiser-v3-desktop"] .pdpv3d-root'
    )).filter(function (root) {
      return root && root.getAttribute('data-pdpv3-mirror') !== 'true';
    });
  }

  function preloadImage(src) {
    if (!src) return;
    if (!window.__pdpv3SinglePreloadImages) {
      window.__pdpv3SinglePreloadImages = {};
    }
    if (window.__pdpv3SinglePreloadImages[src]) return;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
    window.__pdpv3SinglePreloadImages[src] = img;
  }

  function preloadRootImages(root, artworkOnly) {
    if (!root || !root.dataset) return;
    var sources = [
      root.dataset.imageLandscape,
      root.dataset.imagePortrait,
      root.dataset.imageSquare,
      root.dataset.imageFallback
    ];
    if (!artworkOnly) sources = sources.concat([
      root.dataset.sceneSofaImage,
      root.dataset.sceneBlankwallImage,
      root.dataset.sceneGalleryImage,
      root.dataset.sceneCharcoalImage,
      root.dataset.scaleImage,
      root.dataset.overlayLandscape,
      root.dataset.overlayPortrait,
      root.dataset.overlaySquare
    ]);
    sources.forEach(preloadImage);

    if (artworkOnly) return;
    try {
      JSON.parse(root.dataset.agedOverlays || '[]').forEach(function (overlay) {
        preloadImage(overlay && overlay.src);
      });
    } catch (error) {}
  }

  onReady(function () {
    var singleVisualiserPrewarmed = false;

    function prewarmSingleVisualiser() {
      if (singleVisualiserPrewarmed) return;
      singleVisualiserPrewarmed = true;
      getVisualiserRoots().forEach(function (root) {
        var slide = root.closest ? root.closest('.custom-product-main-slide[data-feature="visualiser"], .product-main-slide[data-feature="visualiser"]') : null;
        if (slide && slide.classList) {
          slide.classList.add('pdpv3-target-visualiser-surface');
        }
        preloadRootImages(root, window.__PDP_MOBILE_PERF_OPTIMIZED__ === true);
        if (window.__PDP_MOBILE_PERF_OPTIMIZED__ !== true && root.dispatchEvent) {
          try {
            root.dispatchEvent(new Event('pdpv3:force-render'));
          } catch (error) {}
        }
      });
    }

    function scheduleSingleVisualiserPrewarm() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prewarmSingleVisualiser, { timeout: 1800 });
      } else {
        window.setTimeout(prewarmSingleVisualiser, 900);
      }
      window.setTimeout(prewarmSingleVisualiser, 2200);
    }

    getVisualiserRoots().forEach(function (root) {
      var slide = root.closest ? root.closest('.custom-product-main-slide[data-feature="visualiser"], .product-main-slide[data-feature="visualiser"]') : null;
      if (slide && slide.classList) {
        slide.classList.add('pdpv3-target-visualiser-surface');
      }
    });

    window.__pdpv3SelectVisualiserSlide = function () {
      var flkty = getFlickity();
      if (!flkty || typeof flkty.select !== 'function') return false;

      var visualiserCellIndex = findVisualiserCellIndex(flkty);
      if (visualiserCellIndex < 0) return false;

      try {
        flkty.select(visualiserCellIndex, false, true);
        return true;
      } catch (error) {
        return false;
      }
    };

    function lockToVisualiserSlide() {
      if (typeof window.__pdpv3SelectVisualiserSlide !== 'function') return;
      if (window.__pdpv3SelectVisualiserSlide()) return;
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 80);
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 220);
    }

    document.addEventListener('click', function (event) {
      if (!event || !event.isTrusted) return;
      if (!shouldLockFromNode(event.target)) return;
      lockToVisualiserSlide();
    }, true);

    document.addEventListener('pointerdown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!shouldLockFromNode(event.target)) return;
      if (typeof window.__pdpv3LoadRuntime === 'function') {
        window.__pdpv3LoadRuntime('single-visualiser-intent').then(prewarmSingleVisualiser).catch(function () {});
      } else {
        prewarmSingleVisualiser();
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (!event || !event.isTrusted) return;
      if (!shouldLockFromNode(event.target)) return;
      lockToVisualiserSlide();
    }, true);

    scheduleSingleVisualiserPrewarm();
  });
})();
